/**
 * Get the current environment name
 */
export const getEnvironment = (): string => {
  if (typeof window !== "undefined" && window.NOMATO_ENVIRONMENT) {
    return window.NOMATO_ENVIRONMENT;
  }
  return import.meta.env.MODE || "development";
};

/**
 * Check if running in a preview environment
 */
export const isPreviewEnvironment = (): boolean => {
  return getEnvironment() === "preview";
};

/**
 * Get the application URL for constructing redirects
 */
export const getAppUrl = (): string => {
  const envUrl = import.meta.env.VITE_FRONTEND_URL;
  if (envUrl) return envUrl;

  if (typeof window !== "undefined") {
    return window.location.origin;
  }

  return "http://localhost:5173";
};

/**
 * Get Mapbox configuration from runtime config or environment variables
 */
export const getMapboxConfig = () => {
  if (typeof window !== "undefined" && window.MAPBOX_CONFIG) {
    return window.MAPBOX_CONFIG;
  }
  return {
    token: import.meta.env.VITE_MAPBOX_TOKEN || "",
    style: import.meta.env.VITE_MAPBOX_STYLE || "",
  };
};
